/**
 * HHP Certificates Related Functions
 */

import Vue from 'vue';
import axios from 'axios';

import { SDLUtil } from '@/utils';

/**
    @SerializedName("401") FORBIDDEN,
    @SerializedName("REDIRECT") REDIRECT,

    @SerializedName("HHP_INVALID_REQUEST") HHP_INVALID_REQUEST,

    @SerializedName("HHP_NO_CERTINFO") HHP_NO_CERTINFO,
    @SerializedName("HHP_LOGIN_REQUIRED") HHP_LOGIN_REQUIRED,
    @SerializedName("HHP_CERT_REQUIRED") HHP_CERT_REQUIRED,

    @SerializedName("HHP_MONTH_LOCK") HHP_MONTH_LOCK, // Inactive for more than a month
    @SerializedName("HHP_LOGIN_LOCK") HHP_LOGIN_LOCK, // Too many Login Failures
*/


const hhpErrorCodes = ['REDIRECT', 'HHP_INVALID_REQUEST', 'HHP_NO_CERTINFO', 'HHP_LOGIN_REQUIRED',
'HHP_CERT_REQUIRED', 'HHP_MONTH_LOCK', 'HHP_LOGIN_LOCK'];

const checkCert = () => {
    Vue.$log.info('※ HhpCerts.js GET CERTS');
    /*
    error.message contains redirectUrl
    const redirectUrl = data.error.message;

    this.$router.push({path: '/basis/'})
    */

    return axios
        .get(`${SDLUtil.API_URL}/basis/certificate/CertMain.skp`)
        .then(response => {
            return response;
        })
        .catch(err => {
            Vue.$log.info('※ HhpCerts.js Check Certs', err);
            return err;
        });
};

export default {
/*
    checkCerts() {
        return checkCert();
    },

    async handleHhpAccessError(response, router) {

        if (hhpErrCodes.includes(String(errCode))) {
            Vue.$log.error(`◎ Response error code => ${errCode}`, `${response.data.error.message}`);

            if (router.currentRoute.fullPath.startsWith('/basis/anysvcmobile')) {

            } else if (router.currentRoute.fullPath.startsWith('/basis/certificate')) {
                switch(errCode) {
                    case "HHP_NO_CERTINFO":
                        // HHP Main page gets CertInfo from CertMain.skp
                        // router.push({path: })
                        router.push({path: H})
                        break;
                    case "HHP_LOGIN_REQUIRED":
                        router.push({path: '/basis/certificate/CertLogin'});
                        break;
                    case "HHP_CERT_REQUIRED":
                        router.push({path: '/basis/certificate/CertIssue'});
                        break;
                    case "HHP_MONTH_LOCK":
                        router.push({path: '/basis/anysvcmobile/request/RequestOther'});
                        break;
                }

            }
        }
        Vue.$log.info('※ HhpCerts.js HHP INTERCEPTOR');
        if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
            const { code, message } = response.data.error;

            if (hhpErrorCodes.includes(String(code)) && response.config.url.startsWith('/basis/anysvcmobile')) {
                if (errCode === '403' && errMsg.endsWith('/CertMain.skp')) {
                    const certRes = await checkCerts(response.data);
                    Vue.$log.info('※ HhpCerts.js certRes', certRes);
                    return response;
                return Promise.reject(response);
                }
            }
        }
        return response;
    },
*/
};



// WEBPACK FOOTER //
// ./src/skpComponents/common/HhpCerts.js